var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#dc2424",
    paintOrder: "fill markers stroke",
    d: "M0 0h1000v1000H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M609.877 888.081H764.96V542.496c0-139.36-41.44-231.224-206.57-231.224-57.764 0-125.573 30.62-165.13 93.74l-3.138-293.093H235.04V888.08h155.084V593.114c0-114.362 35.788-160.606 119.922-160.606 72.206 0 99.204 45.62 99.204 138.11V888.08z",
    fill: "#fff"
  })));
}

export default SvgFavicon;